import { render } from "./SuggestionButton.vue?vue&type=template&id=b835808a&scoped=true"
import script from "./SuggestionButton.vue?vue&type=script&lang=js"
export * from "./SuggestionButton.vue?vue&type=script&lang=js"

import "./SuggestionButton.vue?vue&type=style&index=0&id=b835808a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b835808a"]])

export default __exports__